import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.8787 6.9998A3 3 0 0 1 5 6.121h3c.5523 0 1 .4477 1 1s-.4477 1-1 1H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-3c0-.5523.4477-1 1-1s1 .4477 1 1v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 .8787-2.1213",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.7929 2.9142a3.1214 3.1214 0 0 1 4.4142 4.4142l-8.5 8.5a1 1 0 0 1-.7071.2929H8c-.5523 0-1-.4477-1-1v-3c0-.2652.1054-.5195.2929-.7071zM18 4c-.2974 0-.5826.1181-.7929.3284L9 12.5355v1.5858h1.5858l8.2071-8.207A1.1212 1.1212 0 0 0 18 4",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.2929 4.414c.3905-.3905 1.0237-.3905 1.4142 0l3 3c.3905.3905.3905 1.0237 0 1.4142s-1.0237.3905-1.4142 0l-3-3c-.3905-.3905-.3905-1.0237 0-1.4142",
        clipRule: "evenodd"
    }, "2")
], "Edit", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
